// @ts-nocheck

import React, { forwardRef, useCallback } from 'react';
import styled, { css } from 'styled-components';

import theme from '../../styled-components/dark';
import { NewTag } from '../../styled-components/shared';

export const FilterButtonClassName = 'filter-button';
const Wrapper = styled.div`
  margin-right: 0.625em;
  padding: 0.35em 0.625em;
  width: 100%;

  -webkit-tap-highlight-color: transparent;
  align-items: center;
  background: ${theme.MatchBetFilter.default.backgroundColor};
  border-radius: 150em;
  border: 1px solid;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  font-size: 0.95em;
  font-weight: 500;
  justify-content: center;
  user-select: none;

  transition: none 150ms ease-in-out;
  transition-property: border, transform;

  ${({ $isSelected }) =>
    $isSelected
      ? css`
          border-color: var(--MatchBetFilter-selectedBorderColor, ${theme.MatchBetFilter.selected.borderColor});
        `
      : css`
          border-color: ${theme.MatchBetFilter.default.borderColor};
        `}

  &:active {
    transform: scale(0.95);
  }
`;

const Label = styled.span`
  color: ${({ $isSelected }) =>
    $isSelected ? theme.MatchBetFilter.selected.labelColor : theme.MatchBetFilter.default.labelColor};
`;

const Info = styled.span`
  margin-left: 5px;

  color: ${theme.MatchBetFilter.selected.nbBetsColor};
`;

type MatchBetFilterProps = {
  className?: string;
  index?: number;
  label: string;
  info?: number | string;
  onClick: ((index: number) => void) | (() => void);
  isSelected?: boolean;
  children?: React.ReactNode;
  newTag?: boolean;
  'data-testid'?: string;
};

const MatchBetFilter = (
  {
    className = '',
    index,
    label,
    info,
    newTag,
    onClick,
    isSelected = false,
    children,
    ...restProps
  }: MatchBetFilterProps,
  ref,
) => {
  const handleClick = useCallback(() => {
    if (index) {
      onClick(index);
    } else {
      onClick();
    }
  }, [onClick, index]);

  return (
    <Wrapper
      className={`${className} ${FilterButtonClassName}`}
      $isSelected={isSelected}
      onClick={handleClick}
      data-testid={restProps['data-testid']}
      ref={ref}
    >
      {children ? (
        children
      ) : (
        <>
          <Label $isSelected={isSelected}>{label}</Label>
          {info !== null && info !== undefined ? <Info $isSelected={isSelected}>{`(${info})`}</Info> : null}
        </>
      )}

      {newTag ? <NewTag $background>New</NewTag> : null}
    </Wrapper>
  );
};

export default forwardRef(MatchBetFilter);
